import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../environments/environment';

/**
 * Route guard for features switched on per environment (`enabledFeatures`).
 * When the flag is off, a typed URL redirects to the home page.
 */
export function featureGuard(flag: keyof typeof environment.enabledFeatures): CanActivateFn {
    return () => environment.enabledFeatures[flag] ? true : inject(Router).createUrlTree(['/']);
}
